import ToastActions from 'actions/ToastActions';

export const handleSendCodeError = (response: { code: string; error: { endpoint: string[] } }) => {
  if (response && response.code === 'duplicate_device') {
    ToastActions.showErrorToast('This device is already linked to your account.');
  } else if (response && response.code === 'underage_account_conflict') {
    ToastActions.showErrorToast('Please contact support for assistance linking this device.');
  } else if (
    (response && response.code === 'validation_error') ||
    response.code === 'invalid_address'
  ) {
    const message =
      (response.error.endpoint && response.error.endpoint[0]) ||
      'Please enter a valid email address.';
    ToastActions.showErrorToast(message);
  } else {
    console.debug(response);
    console.error(response.toString());
    ToastActions.showDefaultErrorToast();
  }
};
